"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));
var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));
var _react = _interopRequireDefault(require("react"));
var _classnames = _interopRequireDefault(require("classnames"));
var _injectSheet = _interopRequireDefault(require("../../style/injectSheet"));
var _reactIntl = require("react-intl");
var _recompose = require("recompose");
var _Text = require("../../Text/Text");
var _excluded = ["calDate", "classes", "className", "intl", "theme"];
/*:: import { type ThemeType, type InjectSheetProvidedProps } from '../../style/ThemeTypes';*/
var Style = function Style(theme /*: ThemeType*/) {
  return {
    /* Due to the precise nature of the component,
     * pixel measurements are desired */
    root: {
      borderRadius: '.5rem',
      backgroundColor: theme.colors.dullRed,
      display: 'inline-block',
      padding: 0,
      position: 'relative'
    },
    calendar: {
      display: 'inline-block',
      textAlign: 'center'
    },
    text: {
      position: 'absolute',
      width: '100%',
      left: 0,
      top: '.35em',
      textAlign: 'center'
    },
    textDay: {
      fontWeight: 400,
      fontSize: '60%',
      color: theme.colors.pebbleGrey,
      textTransform: 'uppercase'
    },
    textDate: (0, _defineProperty2.default)({
      fontWeight: 400,
      lineHeight: '1.5rem'
    }, theme.breakpoints.gt.tablet.landscape, {
      lineHeight: '1.25rem' /* Account for font scale */
    })
  };
};
/*:: type Props = InjectSheetProvidedProps & {
  calDate: string,
  intl: Object
};*/
var CalendarIcon = function CalendarIcon(_ref /*:: */) {
  var calDate = _ref /*:: */.calDate,
    classes = _ref /*:: */.classes,
    className = _ref /*:: */.className,
    intl = _ref /*:: */.intl,
    theme = _ref /*:: */.theme,
    props = (0, _objectWithoutProperties2.default)(_ref /*:: */, _excluded);
  return /*#__PURE__*/_react.default.createElement("div", (0, _extends2.default)({
    className: (0, _classnames.default)(classes.root, className)
  }, props), /*#__PURE__*/_react.default.createElement("div", {
    className: classes.calendar
  }, /*#__PURE__*/_react.default.createElement("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    width: "64",
    height: "64",
    viewBox: "0 0 64 64",
    className: classes.svg
  }, /*#__PURE__*/_react.default.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/_react.default.createElement("path", {
    fill: "#FFF",
    fillRule: "nonzero",
    d: "M10.54 11.022h42.92c1.03 0 1.866.837 1.866 1.867v40.156c0 1.03-.836 1.866-1.866 1.866H10.54a1.867 1.867 0 0 1-1.866-1.866V12.889c0-1.03.836-1.867 1.866-1.867z"
  }), /*#__PURE__*/_react.default.createElement("path", {
    fill: "#F2F2F2",
    fillRule: "nonzero",
    d: "M8.674 53.045c0 1.03.836 1.866 1.866 1.866h42.92c1.03 0 1.866-.836 1.866-1.866V33.434H8.674v19.61z"
  }), /*#__PURE__*/_react.default.createElement("path", {
    fill: "#2B414D",
    fillRule: "nonzero",
    d: "M8.674 30.632a.933.933 0 0 0-.933.934v2.802a.933.933 0 1 0 1.866 0v-2.802a.933.933 0 0 0-.933-.934zm46.652 0a.933.933 0 0 0-.933.934v2.802a.933.933 0 1 0 1.866 0v-2.802a.933.933 0 0 0-.933-.934z"
  }), /*#__PURE__*/_react.default.createElement("path", {
    fill: "#E5E5E5",
    fillRule: "nonzero",
    d: "M9.607 32.5h44.786v.934H9.607z"
  }), /*#__PURE__*/_react.default.createElement("path", {
    fill: "#B5B5B6",
    fillRule: "nonzero",
    d: "M53.46 53.978H10.54a1.867 1.867 0 0 1-1.866-1.867v.934c0 1.03.836 1.866 1.866 1.866h42.92c1.03 0 1.866-.836 1.866-1.866v-.934c0 1.03-.836 1.867-1.866 1.867z"
  }))), /*#__PURE__*/_react.default.createElement("span", {
    className: classes.text
  }, /*#__PURE__*/_react.default.createElement(_Text.ExtraSmallText, {
    className: classes.textDay
  }, /*#__PURE__*/_react.default.createElement(_reactIntl.FormattedDate, {
    value: calDate,
    weekday: "short"
  })), /*#__PURE__*/_react.default.createElement(_Text.Header1, {
    className: classes.textDate
  }, /*#__PURE__*/_react.default.createElement(_reactIntl.FormattedDate, {
    value: calDate,
    day: "numeric"
  })))));
};
CalendarIcon.displayName = 'CalendarIcon';
var EnhancedCalendarIcon = (0, _recompose.compose)(_reactIntl.injectIntl, (0, _injectSheet.default)(Style))(CalendarIcon);
EnhancedCalendarIcon.displayName = 'CalendarIcon';
var _default = exports.default = EnhancedCalendarIcon;
//# sourceMappingURL=CalendarIcon.js.map